<template>
  <div class="AsistenciasTiemposExtra">
    <md-layout md-flex="100" md-align="center" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="90" md-flex-xlarge="70">
        <md-table-card class="w-100">
          <md-toolbar>
            <h1 class="md-title">
              Tiempos extra pendientes de validar
            </h1>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head>Registrado</md-table-head>
                <md-table-head>Faltó</md-table-head>
                <md-table-head>Fecha inasistencia</md-table-head>
                <md-table-head>Tipo falta</md-table-head>
                <md-table-head>Cubrió</md-table-head>
                <md-table-head>Otorgó</md-table-head>
                <md-table-head>Punto</md-table-head>
                <md-table-head>Turno</md-table-head>
                <md-table-head>Acciones</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="tex in tiemposextra" :key="tex.id_tex">
                <md-table-cell>
                  {{moment(tex.fecha_tex,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}}
                </md-table-cell>
                <md-table-cell>
                  <div v-if="tex.emp_falto">{{tex.emp_falto}}</div>
                  <div v-else>VACANTE</div>
                </md-table-cell>
                <md-table-cell>
                  {{moment(tex.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}}
                </md-table-cell>
                <md-table-cell>
                  <div v-if="tex.tipo_asd === 'asistio'"> Asistencia </div>
                  <div v-if="tex.tipo_asd === 'falta_just_pnh'"> FALTA JUSTIFICADA </div>
                  <div v-if="tex.tipo_asd === 'falta_injust_pnh'"> FALTA INJUSTIFICADA </div>
                  <div v-if="tex.tipo_asd === 'permiso_pnh'"> PERMISO </div>
                  <div v-if="tex.tipo_asd === 'permiso_falle_pnh'"> PERMISO FALLECIMIENTO </div>
                  <div v-if="tex.tipo_asd === 'permiso_naci_pnh'"> PERMISO NACIMIENTO </div>
                </md-table-cell>
                <md-table-cell>{{tex.emp_asignado}}</md-table-cell>
                <md-table-cell>{{tex.emp_otorga}}</md-table-cell>
                <md-table-cell>{{tex.nombre_pun}}</md-table-cell>
                <md-table-cell>
                  {{moment(tex.inicio_ptu,'h:mm:ss').format('h:mm A')}} a {{moment(tex.termino_ptu,'h:mm:ss').format('h:mm A')}}
                </md-table-cell>
                <md-table-cell>
                  <md-button class="md-accent md-raised" style="width:auto" @click.native="abrirModalValidarTiempoExtra(tex)">VALIDAR </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalTiempoExtraPorValidar">
      <md-dialog-content>
        <h2> Validación de tiempo extra </h2>
        <div v-if="tiempo_extra.emp_falto">
          <strong>Faltó: </strong> {{tiempo_extra.emp_falto}}</div>
        <div v-else>
          <strong>Faltó: </strong> VACANTE</div>
        <strong>Cubrió: </strong> {{tiempo_extra.emp_asignado}}<br>
        <strong>Fecha de inasistencia: </strong> {{moment(tiempo_extra.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}}<br>
        <div v-if="tiempo_extra.tipo_asd === 'asistio'">
          <strong>Tipo de falta: </strong> Asistencia </div>
        <div v-if="tiempo_extra.tipo_asd === 'falta_just_pnh'">
          <strong>Tipo de falta: </strong> FALTA JUSTIFICADA </div>
        <div v-if="tiempo_extra.tipo_asd === 'falta_injust_pnh'">
          <strong>Tipo de falta: </strong> FALTA INJUSTIFICADA </div>
        <div v-if="tiempo_extra.tipo_asd === 'permiso_pnh'">
          <strong>Tipo de falta: </strong> PERMISO </div>
        <div v-if="tiempo_extra.tipo_asd === 'permiso_falle_pnh'">
          <strong>Tipo de falta: </strong> PERMISO FALLECIMIENTO </div>
        <div v-if="tiempo_extra.tipo_asd === 'permiso_naci_pnh'">
          <strong>Tipo de falta: </strong> PERMISO NACIMIENTO </div>
        <strong>Punto: </strong> {{tiempo_extra.nombre_pun}}<br>
        <strong>Turno del punto: </strong> {{moment(tiempo_extra.inicio_ptu,'h:mm:ss').format('h:mm A')}} a {{moment(tiempo_extra.termino_ptu,'h:mm:ss').format('h:mm A')}}<br>
        <strong>Otorgó: </strong> {{tiempo_extra.emp_otorga}}<br>
        <md-radio id="vtex1" name="vtex" md-value="aceptado" v-model="estatus_tex">Aprobado</md-radio>
        <md-radio id="vtex2" name="vtex" md-value="negado" class="md-warn" v-model="estatus_tex">No aprobado</md-radio>
        <div v-if="estatus_tex==='negado'">
          <md-input-container>
            <label>Observaciones</label>
            <md-textarea v-model="observaciones_tex"></md-textarea>
          </md-input-container>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalTiempoExtraPorValidar')">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click.native="guardarValidaxionTiempoExtra()">Guardar validación</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>


<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "AsistenciasValidarTiemposExtra",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    obtenerTiemposExtraPorValidar() {
      this.$http
        .post("tiemposextra/pendientes", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "tiemposextra" in response.body) {
              this.tiemposextra = response.body.tiemposextra;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    abrirModalValidarTiempoExtra(tex) {
      this.tiempo_extra = tex;
      this.abrirModal("modalTiempoExtraPorValidar");
    },
    guardarValidaxionTiempoExtra() {
      if (this.validarTEX()) {
        this.$http
          .post("tiemposextra/validar", {
            token: this.$session.get("token"),
            data: {
              id_tex: this.tiempo_extra.id_tex,
              estatus_tex: this.estatus_tex,
              obs_estatus_tex: this.observaciones_tex
            }
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false,
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
              this.tiempo_extra.id_tex = null;
              this.tiempo_extra.fecha_tex = null;
              this.tiempo_extra.id_emn_falto = null;
              this.tiempo_extra.emp_falto = null;
              this.tiempo_extra.emp_asignado = null;
              this.tiempo_extra.emp_otorga = null;
              this.tiempo_extra.emp_valida = null;
              this.tiempo_extra.estatus_tex = null;
              this.tiempo_extra.obs_estatus_tex = null;
              this.tiempo_extra.tipo_asd = null;
              this.tiempo_extra.fecha_asi = null;
              this.tiempo_extra.nombre_pun = null;
              this.tiempo_extra.inicio_ptu = null;
              this.tiempo_extra.termino_ptu = null;
              this.estatus_tex = null;
              this.tiemposextra = null;
              this.obtenerTiemposExtraPorValidar();
              this.cerrarModal("modalTiempoExtraPorValidar");
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarTEX() {
      if (!this.estatus_tex) {
        Snackbar.show({
          text: "Por favor seleccione una opción de validación.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerTiemposExtraPorValidar();
  },
  data() {
    return {
      msg: "AsistenciasValidarTiemposExtra",
      tiemposextra: [],
      tiempo_extra: {
        id_tex: null,
        fecha_tex: null,
        id_emn_falto: null,
        emp_falto: null,
        emp_asignado: null,
        emp_otorga: null,
        emp_valida: null,
        estatus_tex: null,
        obs_estatus_tex: null,
        tipo_asd: null,
        fecha_asi: null,
        nombre_pun: null,
        inicio_ptu: null,
        termino_ptu: null
      },
      estatus_tex: null,
      observaciones_tex: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// AsistenciasValidarTiemposExtra.vue?5a1e26a4